import React, { Component } from 'react';
// import AnimatedWrapper from '../AnimatedWrapper'
import { triggerIntroReveal } from '../App';

import Title from '../../components/navigation/Title'
import Contents from '../../components/contents/Contents'
import Loading from '../../components/pageContent/Loading'
import Hero from '../../components/hero/Hero.js'
import Shutter from '../../components/hero/transitions/Shutter'
import { pushEvent } from '../../utils/analytics.js';

import { getUrl } from '../../utils/services.js'


class Page extends Component {

	constructor(props) {

		super(props)

		this.state = {
			isLoading: false,
			isLoaded: false,
			data: {}
		}

		this.getData = this.getData.bind(this)

	}

	getData() {

		this.setState({
			isLoading: true
		})

		getUrl('/api/work').then((data) => {

			// console.log(data)

			this.setState({
				// title: data.hero.fields.title,
				// subtitle: data.hero.fields.subtitle,
				// work: data.work,
				data,
				isLoading: false,
				isLoaded: true
			}, () => {
				if (this.props.onPageReady) {
					this.props.onPageReady();
				}
				triggerIntroReveal();
			})

		}, function (err, data) {
			console.log(err, data)

		}).catch(function (err) {

			console.log(err)
		})

	}

	componentDidMount() {
		pushEvent();
		this.getData()
	}


	render() {

		const { viewport, title } = this.props
		const { isLoading, isLoaded, data } = this.state

		const { hero, work } = data

		return (
			<div>

				<Title text={title} />

				{isLoading && <Loading />}

				{isLoaded &&
					<div>
						<Hero title={hero.fields.title} subtitle={hero.fields.subtitle} color="#ffc8f0" theme="light" viewport={viewport} isCentered={true}
							media={false}
							background={<Shutter height={100} />}
							showScroll={true}
						/>
						<Contents work={work} />
					</div>

				}

			</div>
		);
	}
}

// const Wrapper = AnimatedWrapper(Page);
export default Page;